import { DoorLidState } from '@eppendorf/vnls-device-service-utils';
import {
  type HasClassName,
  Icon,
  IconSizeClasses,
  Tooltip,
} from '@eppendorf/vnls-react-components';
import type { ReactElement } from 'react';

import { capitalize, decapitalize } from '$shared/utils/string.utils';

export interface DoorOrLidStatusProps extends HasClassName {
  doorState?: DoorLidState | null;
  lidState?: DoorLidState | null;
  fallback?: string;
}

export function DoorOrLidStatusV2({
  doorState,
  lidState,
  fallback,
  className,
}: DoorOrLidStatusProps): ReactElement | undefined | string {
  const doorOrLid: 'door' | 'lid' = doorState ? 'door' : 'lid';

  function getIconByStatus(status?: string | null) {
    switch (status?.toLocaleLowerCase()) {
      case 'open':
      case 'opened':
      case 'opening':
        return <Icon name={`${doorOrLid}-open`} size={IconSizeClasses.XSmall} />;
      case 'locked':
        return <Icon name="lock-locked" size={IconSizeClasses.XSmall} />;
      case 'unlocked':
        return <Icon name="lock-unlocked" size={IconSizeClasses.XSmall} />;
      case 'closed':
      case 'closing':
        return <Icon name={`${doorOrLid}-closed`} size={IconSizeClasses.XSmall} />;
      default:
        return undefined;
    }
  }

  return doorState || lidState ? (
    <Tooltip
      trigger={
        <div className={`inline-block w-max-xxs flex flex__jc--center ${className}`}>
          {getIconByStatus(doorState || lidState)}
        </div>
      }
    >
      {`${capitalize(doorState ? 'door' : 'lid')} ${decapitalize(doorState || lidState || '')}`}
    </Tooltip>
  ) : (
    fallback
  );
}
